module.exports = __webpack_public_path__ + "static/media/infoSelected.526fb924.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/infoSelected.png
// module id = 253
// module chunks = 0